import {
    sanitizeSearchParamKey,
    sanitizeSearchParamValue
} from './sanitizeSearchParams';

/**
 * @params existingParams, newParams - type URLSearchParams
 * @return merged as type URLSearchParams
 */
const mergeSearchParams = ( existingParams, newParams ) =>
{
    const mergedSearchParams = new URLSearchParams( existingParams );
    newParams.forEach( (v,k) =>
    {
        mergedSearchParams.set( sanitizeSearchParamKey(k), sanitizeSearchParamValue(v) )
    })
    return mergedSearchParams;
}

export {mergeSearchParams};
